import "./adBlockedNotice.css";

const DEFAULT_TITLE = "Ad blocked";
const DEFAULT_MESSAGE =
  "Please disable your ad blocker and refresh the page to view this ad.";
const DEFAULT_BUTTON_LABEL = "I disabled it, refresh";

const WarningShieldIcon = () => (
  <svg
    className="adblocked-notice__icon"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2L4 5V10.5C4 16 7.5 20.9 12 22C16.5 20.9 20 16 20 10.5V5L12 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12 7V13"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <circle cx="12" cy="16.5" r="1" fill="currentColor" />
  </svg>
);

export default function AdBlockedNotice({
  variant = "stage",
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  buttonLabel = DEFAULT_BUTTON_LABEL,
}) {
  return (
    <div
      className={`adblocked-notice adblocked-notice--${variant}`}
      role="status"
      aria-live="polite"
    >
      <div className="adblocked-notice__card">
        <div className="adblocked-notice__content">
          <div className="adblocked-notice__title-row">
            <WarningShieldIcon />
            <h3 className="adblocked-notice__title">{title}</h3>
          </div>
          <p className="adblocked-notice__message">{message}</p>
          <button
            type="button"
            className="adblocked-notice__refresh-button"
            onClick={() => window.location.reload()}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
